import React, {useEffect, useState} from "react";
import styles from "./style.module.scss";
import {
  Button,
  Content,
  ContentLayout,
  InputBox,
  ListTable,
  SearchFilter,
} from "@adminComponents";
import {AdminScreenId} from "@assets";
import * as Datas from "@adminData";
import {useAdminNav} from "@hook";
import {useSetRecoilState} from "recoil";
import {adminApi} from "@utils";
import {states} from "@recoils";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faSearch} from "@fortawesome/free-solid-svg-icons";
import moment from "moment";

export default function Page() {
  const setAlertModal = useSetRecoilState(states.alertState);
  const {getParams, navigate} = useAdminNav();
  const {searchTxt: paramsSearchTxt, page: paramsPage = 1} = getParams<{
    searchTxt?: string;
    page?: number;
  }>();
  const [searchTxt, setSearchTxt] = useState(paramsSearchTxt);
  const [listData, setListData] =
    useState<Datas.ResultPagingResponse<Datas.IReview[]>>();

  async function getList({page = 1}: {page?: number} = {}) {
    try {
      const {data, success, message} = await adminApi.review.getList({
        page,
        searchTxt,
      });
      if (success) {
        setListData(data);
      } else {
        setAlertModal({
          isVisible: true,
          title: message || "오류가 발생했습니다",
        });
      }
    } catch (error) {
      console.error("getList error", error);
    }
  }

  function goToDetail({data}: {data?: Datas.IReview} = {}) {
    navigate({
      url: AdminScreenId.REVIEW_DETAIL,
      params: {no: data?.no},
      state: {data},
    });
  }

  function goToListPage(params: {
    group?: string;
    group2?: string;
    searchTxt?: string;
    page?: number;
  }) {
    navigate({
      url: AdminScreenId.REVIEW_LIST,
      params,
    });
  }

  useEffect(() => {
    getList({page: paramsPage});
  }, [location.search]);

  return (
    <div className={styles.container}>
      <ContentLayout title={"리뷰목록"}>
        <SearchFilter
          left={[
            <InputBox
              key={1}
              value={searchTxt}
              onValue={setSearchTxt}
              onEnter={() => {
                goToListPage({
                  page: 1,
                  searchTxt,
                });
              }}
              rightContent={
                <div
                  style={{display: "flex"}}
                  onClick={() => {
                    goToListPage({
                      page: 1,
                      searchTxt,
                    });
                  }}>
                  <FontAwesomeIcon icon={faSearch} />
                </div>
              }
            />,
          ]}
          right={[<Button key={0} text="신규등록" onClick={goToDetail} />]}
        />
        <Content>
          <>
            <ListTable
              paging={listData?.page}
              getList={({page: newPage}) => {
                goToListPage({
                  page: newPage,
                  searchTxt,
                });
              }}>
              <thead>
                <tr>
                  <th>성명</th>
                  <th>날짜</th>
                  <th>상품명</th>
                  <th>별점</th>
                  <th>내용</th>
                  <th>작성일자</th>
                </tr>
              </thead>
              <tbody>
                {(listData?.result || []).length === 0 ? (
                  <tr>
                    <td colSpan={6}>조회된 내용이 없습니다.</td>
                  </tr>
                ) : (
                  <>
                    {(listData?.result || []).map(item => {
                      return (
                        <tr
                          key={item.no}
                          onClick={() => goToDetail({data: item})}>
                          <td>{item.name}</td>
                          <td>
                            {item.review_date
                              ? moment(item.review_date).format("YYYY.MM.DD")
                              : ""}
                          </td>
                          <td>{item.product_name}</td>
                          <td>{item.star}</td>
                          <td>{item.content}</td>
                          <td>
                            {moment(item.created_at).format("YYYY-MM-DD")}
                          </td>
                        </tr>
                      );
                    })}
                  </>
                )}
              </tbody>
            </ListTable>
          </>
        </Content>
      </ContentLayout>
    </div>
  );
}
